module.exports = __webpack_public_path__ + "static/media/Novozymes-Rg.5708b699.woff";